import { render, staticRenderFns } from "./PartnerCredit.vue?vue&type=template&id=3cf5079e&"
import script from "./PartnerCredit.vue?vue&type=script&lang=js&"
export * from "./PartnerCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports